import {useTheme} from '@mui/material';
import {usePrint} from 'presentation/hooks';
import {openGoogleMaps} from 'presentation/modules/booking/shared/utils/openGoogleMaps';
import {FlowEnum} from 'presentation/modules/booking/shared/constants/flowEnum';
import {useBookingTheme} from 'presentation/modules/booking/shared/hooks/useBookingTheme';
import {useCalendarEvent} from 'presentation/modules/booking/shared/hooks/useCalendarEvent';
import {useMediaQueries} from 'presentation/pages';
import {AppointmentsHomeStateType} from 'presentation/pages/private/home/types';
import {
	formatText,
	getAddressforMaps,
	getAllMonths,
	getCityAndUfByRegex,
	getUfName,
} from 'presentation/utils';

export function useOdontoConfirmationBookingContent(bookedAppointment: AppointmentsHomeStateType) {
	const {isMobile, isTablet, betweenMobileAndDesktop, isDesktop} = useMediaQueries();
	const {isPrinting, printContent, printRef} = usePrint();
	const {iconName, alertTitle} = useBookingTheme({flowType: FlowEnum.ODONTO});
	const calendarEvent = useCalendarEvent(bookedAppointment);
	const {colors} = useTheme();

	const {
		clinicName,
		formattedAddress,
		formattedDateWithWeekday,
		hour,
		date,
		phoneNumbers,
		providerName,
		specialtyName,
		protocolNumber,
	} = bookedAppointment;

	const [day, month] = date.split(' ')[0].split('/');
	const months = getAllMonths();
	const monthName = months[Number(month) - 1].slug;
	const hasPhoneNumbers = phoneNumbers && phoneNumbers.length !== 0;
	const address = getAddressforMaps(formattedAddress);
	const {city, uf, district} = getCityAndUfByRegex(formattedAddress);

	const addressFormatted = {
		first: formatText(district),
		second: `${city}/${getUfName(uf)}`,
	};

	const handleOpenGoogleMaps = () => openGoogleMaps(address.addressForMaps || '');

	return {
		isMobile,
		isTablet,
		betweenMobileAndDesktop,
		isPrinting,
		printContent,
		printRef,
		iconName,
		alertTitle,
		calendarEvent,
		colors,
		clinicName,
		formattedAddress,
		formattedDateWithWeekday,
		hour,
		date,
		phoneNumbers,
		providerName,
		specialtyName,
		protocolNumber,
		day,
		monthName,
		handleOpenGoogleMaps,
		addressFormatted,
		hasPhoneNumbers,
		isDesktop,
	};
}
